import script from "./Carregamento.vue?vue&type=script&setup=true&lang=js"
export * from "./Carregamento.vue?vue&type=script&setup=true&lang=js"

import "./Carregamento.vue?vue&type=style&index=0&id=67440622&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67440622"]])

export default __exports__